import { currencyTypes } from "@app/currency";

const formatter = {
    money: (value: number|undefined, currency?: currencyTypes.ICurrency, fractionDigits = 0): string => {
        if (! value) {
            return "-";
        }

        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: (currency?.code || "EUR"),
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits,
        }).format(value);
    },

    number: (value: number|undefined): string => {
        if (! value) {
            return "-";
        }

        return Intl.NumberFormat().format(value);
    },

    percentage: (value: number|undefined): string => {
        if (! value) {
            return "-";
        }

        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value) + "%";
    },
}

export { formatter };
